var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoFailedRecording = function SvgIcoFailedRecording(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10m.096-14H8v8h1.763v-3.198h.87L12.305 15h2.113l-2.034-3.379q.848-.158 1.288-.745.441-.6.441-1.447 0-.7-.249-1.163a1.86 1.86 0 0 0-.655-.746 2.6 2.6 0 0 0-.96-.396A5 5 0 0 0 11.096 7m-.294 3.31h-1.04V8.493h1.153q.237 0 .486.033.25.034.44.136.193.09.317.271.125.18.125.486 0 .328-.147.509a.83.83 0 0 1-.35.27 1.8 1.8 0 0 1-.487.102q-.259.012-.497.012",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "m19.5 13.552 4.778 8.274a1.733 1.733 0 0 1-1.501 2.6zm0 0a1.733 1.733 0 0 0-3 0l-4.778 8.274zm-6.277 10.873h9.554l-11.055-2.599a1.733 1.733 0 0 0 1.5 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M17.15 13.927 12.371 22.2a.983.983 0 0 0 .85 1.474h9.555a.983.983 0 0 0 .851-1.474l-4.777-8.274a.983.983 0 0 0-1.702 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.063 16.479h-.125a.556.556 0 0 0-.556.555v2.656c0 .307.25.555.556.555h.125a.556.556 0 0 0 .555-.555v-2.656a.556.556 0 0 0-.555-.555M18 22.351a.618.618 0 1 0 0-1.235.618.618 0 0 0 0 1.235"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcoFailedRecording;